import { morphism } from 'morphism';
import { createStrictSchema } from '../../utils/morph.js';

const favStatisticsSchema = createStrictSchema({
    counter: {
        path: 'counter',
        fn: (propertyValue) => ({
            value: Number(propertyValue.key),
        }),
    },
});
const favoriteAdSchema = createStrictSchema({
    urn: 'urn',
    insertDate: {
        path: 'insert_date',
        fn: (propertyValue) => new Date(propertyValue),
    },
});
const favoriteAdsResponseSchema = createStrictSchema({
    favorites: {
        path: 'favorite_ads',
        fn: morphism(favoriteAdSchema),
    },
});

export { favStatisticsSchema, favoriteAdSchema, favoriteAdsResponseSchema };
//# sourceMappingURL=morph.js.map
